'use client'

import * as React from 'react'
import { cn } from "@shared/utils"
import { useFormField } from '../../hooks/useFormField'

/**
 * @group Components
 * 
 * @summary
 * <blockquote>Displays validation error messages or custom children.</blockquote>
 * 
 * @example
 * ```typescript
 * import { FormMessage } from '@shared/ui'
 * 
 * <FormMessage />
 * ```
 */
export const FormMessage = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, children, ...props }, ref) => {
  const { error, formMessageId } = useFormField()
  const body = error ? String(error?.message) : children

  if (!body) {
    return null
  }

  return (
    <p
      ref={ref}
      id={formMessageId}
      className={cn('text-[0.8rem] font-medium text-destructive', className)}
      {...props}
    >
      {body}
    </p>
  )
})
FormMessage.displayName = 'FormMessage' 